import { hideVisually } from 'polished';
import { css } from 'styled-components';

/**
 * Other useful Bulma helpers
 * https://bulma.io/documentation/helpers/other-helpers/
 */

const otherCss = css`
  .is-clipped {
    overflow: hidden;
  }

  .is-relative {
    position: relative;
  }

  .is-clickable {
    cursor: pointer;
  }

  .is-absolute-cover {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .is-fixed-cover {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .is-visually-hidden {
    ${hideVisually}
  }
  
  .is-scrollbar-hidden {
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      background: transparent;
    }
  }
`;

export default otherCss;
